import React, { useCallback, useEffect } from "react";
import help from "./../../../assets/inputGraphEditor/help.svg";
import {
  Box,
  Typography,
  Tooltip,
  Button,
  TextField,
  MobileStepper,
  Paper,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
// import { ChevronLeft, ChevronRight, MousePointer, Maximize2, Minimize2, FileJson, Grid, Move, PenTool } from 'lucide-react';
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  resetNodesState,
  updatePlotHeight,
  updatePlotWidth,
} from "../../../redux/features/nodes";
import { RootState } from "../../../redux/store";
import { useLocation } from "react-router-dom"; //

/*const steps = [
  {
    title: "Create Canvas Nodes",
    description:
      "Double click on the canvas to create nodes. These nodes represent rooms or spaces in your floor plan. You can create multiple nodes and position them as needed.",
  },
  {
    title: "Connect Your Nodes",
    description:
      "Click and drag from one node to another to create connections. These connections define the relationships and adjacencies between different spaces in your floor plan.",
  },
  {
    title: "Edit Node Properties",
    description:
      "Double click any node to open the Node Editor. Here you can rename nodes, set dimensions (width/length), and delete nodes if needed.",
  },
  {
    title: "Configure Units",
    description:
      "Use the unit toggle to switch between Feet and Meters. All dimensions will automatically update to reflect your chosen unit of measurement.",
  },
  {
    title: "Edit Plot Size",
    description:
      "Plot width and length are optional. If provided, all generated layouts will adhere to the given size limits, ensuring the floorplans fit within your specified dimensions.",
  },
  {
    title: "Edit Layouts",
    description:
      "After generating floorplans, select a floorplan from the list and click on Edit Layout. This will take you to the Output Editor, where you can customize walls, doors, and other properties as needed.",
  },
  {
    title: "Generate & Export",
    description:
      "Once your nodes are set up, select a floor plan from the sidebar and click Generate Floorplans. You can export your work as JSON for later use or DXF for CAD software.",
  },
];*/

interface BottomNavProps {
  isSideBarCollapsed?: boolean;
}
export default function BottomNav({
  isSideBarCollapsed = true,
}: BottomNavProps) {
  const theme = useTheme();

  const unit = useSelector(
    (state: RootState) => state.outputEditorButtonState.unit,
  );


  const dispatch = useDispatch();
  const location = useLocation();
  const { plotWidth: initialPlotWidth, plotHeight: initialPlotHeight } = location.state || {};
  console.log("PAssED HEIGHT AND WIDTH: ", initialPlotWidth, initialPlotHeight)
  const plotWidth = useSelector((state: any) => state.nodesState.plotWidth);
  const plotHeight = useSelector((state: any) => state.nodesState.plotHeight);
  const handleWidthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updatePlotWidth(Number(event.target.value)));
  };

  const handleHeightChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updatePlotHeight(Number(event.target.value)));
  };
  useEffect(() => {
    // If plotWidth or plotHeight is passed from location, update the Redux state
    if (initialPlotWidth && initialPlotHeight) {
      dispatch(updatePlotWidth(initialPlotWidth));
      dispatch(updatePlotHeight(initialPlotHeight));
    }
  }, [initialPlotWidth, initialPlotHeight, dispatch]);
  // useEffect(() => {
  //   //update plot width and height if state changes from elsewhere
  //   console.log(plotHeight);
  // }, [plotHeight]);



  return (
    <div
      data-tour="plot-size"
      style={{
        position: "fixed",
        zIndex: 1000,
        left: "15px",
        bottom: "15px",
        width: "21%",
        height: "65px"
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

        }}
      >

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            paddingRight: "1rem",
            bottom: "15px",
          }}
        >



          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#FBE5C6",
              /*border: "2px solid #FF9A56",*/
              borderRadius: "8px",
              padding: "3px 3px",
            }}
          >
            <Typography
              sx={{
                pr: "12px",
                color: "#1a1a1a",
                textAlign: "left",
                fontFamily: "Poppins",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                textTransform: "uppercase",
              }}
            >
              Plot Size
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#FBE5C6",
                borderRadius: "8px",
                padding: "6px 12px",
              }}
            >
              {/* <Typography
                sx={{
                  pr: "15px",
                  color: "#333333",
                  textAlign: "left",
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "24px",
                }}
              >
                Width
              </Typography> */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "white",
                  borderRadius: "8px",
                  border: "2px solid #1a1a1a",
                  padding: "4px 8px",
                }}
              >
                <TextField
                  label={`Width (${unit === "feet" ? "ft" : "m"})`}
                  variant="standard"
                  size="small"
                  value={plotWidth}
                  onChange={handleWidthChange}
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    marginRight: ".25rem",
                    backgroundColor: "transparent",
                    "& .MuiInputBase-input": {
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        fontSize: "14px",
                    },
                    "& .MuiInputLabel-root": {
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        fontWeight: 500,
                    }
                  }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#FBE5C6",
                borderRadius: "8px",
                padding: "6px 12px",
              }}
            >
              {/* <Typography
                sx={{
                  pr: "15px",
                  color: "#333333",
                  textAlign: "left",
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "24px",
                }}
              >
                Height
              </Typography> */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "white",
                  borderRadius: "8px",
                  border: "2px solid #1a1a1a",
                  padding: "4px 8px",
                }}
              >
                <TextField
                  label={`Length (${unit === "feet" ? "ft" : "m"})`}
                  variant="standard"
                  size="small"
                  value={plotHeight}
                  onChange={handleHeightChange}
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "transparent",
                    "& .MuiInputBase-input": {
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        fontSize: "14px",
                    },
                    "& .MuiInputLabel-root": {
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        fontWeight: 500,
                    }
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* </Box> */}
      {/* // </Box> */}
    </div>
  );
}
